import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isAuth: null,
    userDetails: null,
    school: null,
    fetchAuthFinish: null,
    initAuthDetails: false
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        logout(state, action) {
            state.user = action.payload.user;
            state.isAuth = action.payload.isAuth;
        },
        init(state, action) {
            state.isAuth = action.payload.isAuth;
            state.user = action.payload.claims ? Object.assign({}, ...action.payload.claims.map(x => { return { [x.type]: x.value } })) : null;
            state.isAdmin = action.payload.user?.isAdmin;
            state.isStudent = state.user?.isstudent === 'Yes' ? true : false;
            state.fetchAuthFinish = true;
            state.initAuthDetails = action.payload.initAuthDetails;
        },
        setUserDetails(state, action) {
            state.userDetails = action.payload;
        },
        setSchool(state, action) {
            state.school = action.payload;
        },
        setUserDetailsAndSchool(state, action) {
            state.userDetails = action.payload.userDetails;
            state.school = action.payload.school;
            state.initAuthDetails = true;
        },
        updateUserClaims(state, action) {
            if (action.payload)
                state.user = { ...state.user, ...action.payload }
        },
        setDefaultSchool(state, action) {
            state.userDetails = { ...state.userDetails, defaultSchool: action.payload }
        },
    }
})

export const authActions = authSlice.actions;
export default authSlice
